

// [BD feat] subascription js start here  :- https://prnt.sc/REZNFT3H86sG
(function() {
  'use strict';

  function updateVariantPriceDisplay() {
    const selectedPurchaseOption = document.querySelector('.spare_im_subscription input[name="radio-group"]:checked');
    const purchaseOptionValue = (selectedPurchaseOption?.getAttribute('data-value') || '').trim();
    const formSellingPlanId = document.querySelector('form[action*="/cart/add"] input[name="selling_plan"]')?.value || '';
    const buttonSellingPlanId = document.querySelector('button[add-subscription-data]')?.getAttribute('recharge_plan_id') || '';
    const buttonSubscriptionData = document.querySelector('button[add-subscription-data]')?.getAttribute('add-subscription-data') || '';
    const showSubscriptionPrice = !!(formSellingPlanId || buttonSellingPlanId || buttonSubscriptionData) || (!!selectedPurchaseOption && purchaseOptionValue !== 'Einmaliger Kauf');

    document.querySelectorAll('.price_display_container').forEach(priceContainer => {
      priceContainer.classList.toggle('show_selling_plan_price', showSubscriptionPrice);
    });

  }

  document.addEventListener('change', function(event) {
    if (event.target.matches('.spare_im_subscription input[name="radio-group"]')) {
      updateVariantPriceDisplay();
    }
  });

  document.addEventListener('click', function(event) {
    const subscriptionBlock = event.target.closest('.spare_im_subscription .subscription_block');
    if (!subscriptionBlock) return;

    const radio = subscriptionBlock.querySelector('input[name="radio-group"]');
    if (!radio) return;

    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateVariantPriceDisplay();
  }, true);

  document.addEventListener('click', function(event) {
    if (!event.target.closest('recharge-subscription-widget')) return;

    setTimeout(updateVariantPriceDisplay, 0);
    setTimeout(updateVariantPriceDisplay, 100);
    setTimeout(updateVariantPriceDisplay, 300);
  }, true);

  document.addEventListener('change', function(event) {
    if (
      event.target.closest('recharge-subscription-widget') ||
      event.target.matches('input[name="selling_plan"], select[name="selling_plan"]')
    ) {
      setTimeout(updateVariantPriceDisplay, 0);
    }
  }, true);

  const rechargePriceObserver = new MutationObserver(updateVariantPriceDisplay);

  document.addEventListener('DOMContentLoaded', function() {
    const addToCartForm = document.querySelector('form[action*="/cart/add"]');
    const rechargeWidget = document.querySelector('recharge-subscription-widget');

    if (addToCartForm) {
      rechargePriceObserver.observe(addToCartForm, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }

    if (rechargeWidget) {
      rechargePriceObserver.observe(rechargeWidget, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    const test1Radio = document.getElementById('test1');
    const addToCartBtn = document.querySelector('button[add-subscription-data]');

    if (test1Radio && addToCartBtn) {
      test1Radio.addEventListener('click', function () {
        addToCartBtn.setAttribute('add-subscription-data', '');
        addToCartBtn.setAttribute('recharge_plan_id', '');
        const form = addToCartBtn.closest('form');
        const sellingPlanInput = form?.querySelector('input[name="selling_plan"]');
        if (sellingPlanInput) {
          sellingPlanInput.value = '';
        }
        updateVariantPriceDisplay();
      });
    }

    updateVariantPriceDisplay();
    setTimeout(updateVariantPriceDisplay, 500);
  });

  window.addEventListener('load', updateVariantPriceDisplay);
  document.addEventListener('shopify:section:load', updateVariantPriceDisplay);
})();


//  [BD feat] subascription js start here  :- https://prnt.sc/REZNFT3H86sG
(function() {
  'use strict';
  document.addEventListener('DOMContentLoaded', function() {
     setTimeout(() => {
      const targetBtn = document.querySelector("#sdev_target_btn1");
      if (targetBtn) {
        targetBtn.click();
      }
    }, 100);
    const einmaligerKaufRadio = document.getElementById('test1');
    const abonnementRadio = document.getElementById('test2');
    const planDaysContainer = document.querySelector('.select-product-plan-days');
    const planSelect = document.querySelector('select[name="selling_plan"]');
    const addToCartButton = document.querySelector('button[name="add"]');

    function syncCartFormFields() {
      if (!addToCartButton) return;

      const form = addToCartButton.closest('form');
      const selectedOfferInput = document.querySelector('.choose_an_offer_box input[type="radio"]:checked');
      const selectedPurchaseOption = document.querySelector('.spare_im_subscription input[name="radio-group"]:checked');
      const purchaseOptionValue = (selectedPurchaseOption?.getAttribute('data-value') || '').trim();
      const currentPlanId = form?.querySelector('input[name="selling_plan"]')?.value || addToCartButton.getAttribute('recharge_plan_id') || addToCartButton.getAttribute('add-subscription-data') || '';
      const isSubscription = selectedPurchaseOption ? purchaseOptionValue !== 'Einmaliger Kauf' : !!currentPlanId;
      const variantId = selectedOfferInput?.getAttribute('get_variant_id') || addToCartButton.getAttribute('pass_variant-id') || '';
      const selectedPlanValue = planSelect?.value && !planSelect.value.includes('Wähle') ? planSelect.value : '';
      const sellingPlanId = isSubscription ? (addToCartButton.getAttribute('recharge_plan_id') || selectedPlanValue || currentPlanId) : '';

      if (variantId) {
        addToCartButton.setAttribute('pass_variant-id', variantId);
      }

      if (!form) return;

      const variantInput = form.querySelector('input[name="id"]');
      const sellingPlanInput = form.querySelector('input[name="selling_plan"]');

      if (variantInput && variantId) {
        variantInput.value = variantId;
      }

      if (sellingPlanInput) {
        sellingPlanInput.value = sellingPlanId;
      }
    }

    function togglePlanDropdown() {
      if (abonnementRadio && abonnementRadio.checked) {
        if (planDaysContainer) {
          planDaysContainer.style.display = 'block';
        }
        const select = document.querySelector('.custom-select');

        if (select) {
          const option30 = [...select.options].find(
            opt => opt.getAttribute('custom-data-plan') === "Delivery every 30 days"
          );

          if (option30) {
            option30.selected = true;
            const event = new Event('change', { bubbles: true });
            select.dispatchEvent(event);
          }
        }
      } else {
        if (planDaysContainer) {
          planDaysContainer.style.display = 'none';
        }
        if (addToCartButton) {
          addToCartButton.setAttribute('add-subscription-data', '');
          addToCartButton.setAttribute('custom_data_plan', '');
          addToCartButton.setAttribute('recharge_plan_id', '');
          syncCartFormFields();
        }
        removeActiveClassFromAllRadios();
      }
    }

    function removeActiveClassFromAllRadios() {
      const radioButtons = document.querySelectorAll('input[type="radio"][recharge_plan_id]');
      radioButtons.forEach(radio => {
        radio.classList.remove('active');
        const parentBox = radio.closest('.choose_an_offer_box');
        if (parentBox) {
          parentBox.classList.remove('active');
        }
      });
    }

    function simulateClickOnMatchingRadio(rechargeplanId) {
      if (rechargeplanId) {
        const matchingRadio = document.querySelector(
          `input[type="radio"][recharge_plan_id="${rechargeplanId}"]`
        );
        if (matchingRadio) {
          matchingRadio.click();
          const parentBox = matchingRadio.closest('.choose_an_offer_box');
          if (parentBox) {
            const clickEvent = new Event('click', { bubbles: true, cancelable: true });
            parentBox.dispatchEvent(clickEvent);
          }
        }
      }
    }

    function addActiveClassToMatchingRadio(rechargeplanId) {
      removeActiveClassFromAllRadios();
      if (rechargeplanId) {
        const matchingRadio = document.querySelector(
          `input[type="radio"][recharge_plan_id="${rechargeplanId}"]`
        );
        if (matchingRadio) {
          matchingRadio.classList.add('active');
          const parentBox = matchingRadio.closest('.choose_an_offer_box');
          if (parentBox) {
            parentBox.classList.add('active');
          }
        }
      }
    }

    function updateButtonAttributes() {
      if (planSelect && addToCartButton) {
        const selectedOption = planSelect.options[planSelect.selectedIndex];
        if (selectedOption && selectedOption.value !== 'Wähle deinen Lieferrhythmus') {
          const planValue = selectedOption.value;
          const customDataPlan = selectedOption.getAttribute('custom-data-plan') || '';

          addToCartButton.setAttribute('add-subscription-data', planValue);
          addToCartButton.setAttribute('custom_data_plan', customDataPlan);
          addToCartButton.setAttribute('recharge_plan_id', planValue);
          syncCartFormFields();

          addActiveClassToMatchingRadio(planValue);
          simulateClickOnMatchingRadio(planValue);
        } else {
          addToCartButton.setAttribute('add-subscription-data', '');
          addToCartButton.setAttribute('custom_data_plan', '');
          addToCartButton.setAttribute('recharge_plan_id', '');
          syncCartFormFields();
          removeActiveClassFromAllRadios();
        }
      }
    }

    // ✅ Null-safe event bindings
    if (einmaligerKaufRadio) {
      einmaligerKaufRadio.addEventListener('change', togglePlanDropdown);
    }
    if (abonnementRadio) {
      abonnementRadio.addEventListener('change', togglePlanDropdown);
    }
    if (planSelect) {
      planSelect.addEventListener('change', updateButtonAttributes);
    }
    document.querySelectorAll('.choose_an_offer_box input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', syncCartFormFields);
    });

    togglePlanDropdown();
    syncCartFormFields();
  });
})();



// [BD feat]  Alternative approach using event delegation (more efficient for dynamic content) :- https://prnt.sc/eCAHvFzCF2-E
(function() {
  'use strict';
  document.addEventListener('change', function(event) {
    if (event.target.name === 'radio-group') {
        const planDaysContainer = document.querySelector('.select-product-plan-days');
        const addToCartButton = document.querySelector('button[name="add"]');

        if (event.target.getAttribute('data-value') === 'Abonnement') {
            planDaysContainer.style.display = 'block';
        } else if (event.target.getAttribute('data-value') === 'Einmaliger Kauf') {
            planDaysContainer.style.display = 'none';
            if (addToCartButton) {
                addToCartButton.setAttribute('add-subscription-data', '');
                addToCartButton.setAttribute('custom_data_plan', '');
                addToCartButton.setAttribute('recharge_plan_id', '');
            }
            const radioButtons = document.querySelectorAll('input[type="radio"][recharge_plan_id]');
            radioButtons.forEach(radio => {
                radio.classList.remove('active');
                const parentBox = radio.closest('.choose_an_offer_box');
                if (parentBox) {
                    parentBox.classList.remove('active');
                  document.querySelector('.choose_an_offer_pdp_page').classList.remove('recharge');
                }
            });
        }
    }
    if (event.target.name === 'selling_plan') {
        const addToCartButton = document.querySelector('button[name="add"]');
        const selectedOption = event.target.options[event.target.selectedIndex];

        if (selectedOption && addToCartButton && selectedOption.value !== 'Wähle deinen Lieferrhythmus') {
            const planValue = selectedOption.value;
            const customDataPlan = selectedOption.getAttribute('custom-data-plan') || '';
            addToCartButton.setAttribute('add-subscription-data', planValue);
            addToCartButton.setAttribute('custom_data_plan', customDataPlan);
            addToCartButton.setAttribute('recharge_plan_id', planValue);
            const radioButtons = document.querySelectorAll('input[type="radio"][recharge_plan_id]');
            radioButtons.forEach(radio => {
                radio.classList.remove('active');
                const parentBox = radio.closest('.choose_an_offer_box');
                if (parentBox) {
                    parentBox.classList.remove('active');
                    document.querySelector('.choose_an_offer_pdp_page').classList.remove('recharge');
                }
            });
            const matchingRadio = document.querySelector(`input[type="radio"][recharge_plan_id="${planValue}"]`);
            if (matchingRadio) {
                matchingRadio.classList.add('active');
                const parentBox = matchingRadio.closest('.choose_an_offer_box');
                if (parentBox) {
                    parentBox.classList.add('active');
                    document.querySelector('.choose_an_offer_pdp_page').classList.add('recharge');
                }
                matchingRadio.click();
                if (parentBox) {
                    const clickEvent = new Event('click', {
                        bubbles: true,
                        cancelable: true
                    });
                    parentBox.dispatchEvent(clickEvent);
                }
            }
        } else if (addToCartButton) {
            addToCartButton.setAttribute('add-subscription-data', '');
            addToCartButton.setAttribute('custom_data_plan', '');
            addToCartButton.setAttribute('recharge_plan_id', '');
            const radioButtons = document.querySelectorAll('input[type="radio"][recharge_plan_id]');
            radioButtons.forEach(radio => {
                radio.classList.remove('active');
                const parentBox = radio.closest('.choose_an_offer_box');
                if (parentBox) {
                    parentBox.classList.remove('active');
                   document.querySelector('.choose_an_offer_pdp_page').classList.remove('recharge');
                }
            });
        }
    }
});

 document.addEventListener('click', function(event) {
  const clickedBox = event.target.closest('.choose_an_offer_box');
  if (!clickedBox) return;

  const frequencyTime = clickedBox.getAttribute('frequency_time');
  const planPrice = clickedBox.getAttribute('plan_price');
  const planCompareAtPrice = clickedBox.getAttribute('plan_compare_at_price');

  const radio = clickedBox.querySelector('input[type="radio"][recharge_plan_id]');

  if (radio) {
    const ctaButton = document.querySelector(".custom-cta_button button");
    if (ctaButton) {
      ctaButton.setAttribute("frequency_time", frequencyTime);
    }

    const priceContainer = document.querySelector('[subscription-bundle-price]');
    const actualPriceContainer = document.querySelector('[actual-bundle-price]');

    if (priceContainer) {
      priceContainer.innerHTML = `
        <span style="text-decoration: line-through;">${planCompareAtPrice}</span>
        ${planPrice}
      `;
    }

    if (actualPriceContainer) {
      actualPriceContainer.innerHTML = planCompareAtPrice;
    }
  }
});

})();



// [BD feat] store itmes
(function() {
  'use strict';
  window.addEventListener("load", function () {
  const shouldRefresh = localStorage.getItem("goBackRefresh");

  if (shouldRefresh === "true") {
    localStorage.setItem("goBackRefresh", "false"); // reset it
    window.location.reload(); // force a reload
  }
});
})();



// [BD feat]  subscription on click selected data fecth: https://prnt.sc/47RFjVXrSV-x
(function() {
  'use strict';
  document.addEventListener("DOMContentLoaded", function () {
    const radios = document.querySelectorAll('input[name="radio-group"]');
    const targetBtn = document.querySelector('[add-subscription-data]');

    if (radios.length && targetBtn) {
      radios.forEach(radio => {
        radio.addEventListener('change', function() {
          const val = this.getAttribute('data-value') || '';
          targetBtn.setAttribute("choose_subscription", val);

        
          if (val === "Einmaliger Kauf") {
            targetBtn.setAttribute("recharge_plan_id", "");
            targetBtn.setAttribute("custom_data_plan", "");
            targetBtn.setAttribute("frequency_time", "");
          }
        });
      });

      const checkedRadio = document.querySelector('input[name="radio-group"]:checked');
      if (checkedRadio) {
        targetBtn.setAttribute("choose_subscription", checkedRadio.getAttribute("data-value"));
      }
    }

    
    document.body.addEventListener("click", function (event) {
      const button = event.target.closest("[add-subscription-data]");

      if (button) {
        event.preventDefault();

        const form = button.closest('form');
        const selectedOfferInput = document.querySelector('.choose_an_offer_box input[type="radio"]:checked');
        const selectedPurchaseOption = document.querySelector('.spare_im_subscription input[name="radio-group"]:checked');
        const purchaseOptionValue = (selectedPurchaseOption?.getAttribute('data-value') || '').trim();
        const variantId = selectedOfferInput?.getAttribute('get_variant_id') || form?.querySelector('input[name="id"]')?.value || button.getAttribute("pass_variant-id");
        const formSellingPlanId = form?.querySelector('input[name="selling_plan"]')?.value || '';
        const buttonSellingPlanId = button.getAttribute("recharge_plan_id") || button.getAttribute("add-subscription-data") || '';
        const planCandidate = formSellingPlanId && !formSellingPlanId.includes('Wähle') ? formSellingPlanId : buttonSellingPlanId;
        const isSubscription = purchaseOptionValue !== 'Einmaliger Kauf' && !!planCandidate;
        const sellingPlanId = isSubscription ? planCandidate : '';
        const customPlan = button.getAttribute("custom_data_plan");
        const frequency_time = button.getAttribute("frequency_time");

        const formData = {
          items: [{
            id: variantId,
            quantity: 1,
            properties: {}
          }]
        };

        
        if (isSubscription) {
          if (sellingPlanId) {
            formData.items[0].selling_plan = sellingPlanId;
          } else if (frequency_time) {
            formData.items[0].properties['frequency_time'] = frequency_time;
          }
          if (customPlan) {
            formData.items[0].properties['Subscription Plan'] = customPlan;
          }
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json().then(data => {
            if (!response.ok) {
              throw data;
            }
            return data;
          });
        })
        .then(data => {
          localStorage.setItem("goBackRefresh", "true");

          setTimeout(()=>{
            document.querySelector('[aria-controls="cart-drawer"]').click();

            fetch(`${Shopify.routes.root}?section_id=cart-drawer`)
            .then(response => response.text())
            .then(carthtml => {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = carthtml;

              const newCartDrawer = tempDiv.querySelector('cart-drawer');
              const existingCartDrawer = document.querySelector('cart-drawer');

              if (newCartDrawer && existingCartDrawer) {
                existingCartDrawer.innerHTML = newCartDrawer.innerHTML;
              }
            })
            .catch(error => {
              console.error('Error fetching cart drawer:', error);
            });
          },100);
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
        });
      }
    });
  });
})();



